import { Button, Card, Skeleton } from 'antd'
import moment from 'moment'
import { FC, useState } from 'react'
import { FCC } from 'types'
import followupboss from '../images/followupboss.svg'
import { FubData } from '../types'
import FubIntergrationModal from './FubIntergrationModal'

const syncDirectionLabel: Record<string, string> = {
 twoway: 'Two-way sync',
 push: 'AgentRoof → Follow Up Boss',
 pull: 'Follow Up Boss → AgentRoof',
}

const FubIntegrationCard: FC<{
 isLoading?: boolean
 data?: FubData
}> = ({ data, isLoading }) => {
 const [showModal, setShowModal] = useState(false)
 return (
  <>
   <Card className="int-card-new int-card-new-fub">
    {isLoading ? (
     <Skeleton />
    ) : (
     <>
      <div className="int-card-new-header">
       <img
        className="int-card-new-img int-card-new-img-fub"
        src={followupboss}
        alt=""
       />
      </div>
      {data?.connected ? (
       <div className="twilio-list-blk">
        <ItemBlk label="Status" value="Connected" />
        {data.sync_direction && (
         <ItemBlk
          label="Sync Direction"
          value={syncDirectionLabel[data.sync_direction]}
         />
        )}
        <ItemBlk
         label="Last Synced"
         value={
          data.last_synced_at
           ? moment(data.last_synced_at).format('MMM DD, YYYY h:mm A')
           : 'Never synced'
         }
        />
        <Button
         className="mt-2"
         onClick={() => setShowModal(true)}
         shape="round"
         type="link"
        >
         View All
        </Button>
       </div>
      ) : (
       <div className="text-center">
        <p>
         Sync your AgentRoof leads and contacts with Follow Up Boss — two-way or
         one-way, your choice.
        </p>
        <Button onClick={() => setShowModal(true)} shape="round" type="primary">
         Connect Now
        </Button>
       </div>
      )}
     </>
    )}
   </Card>
   {showModal && (
    <FubIntergrationModal
     data={data}
     onCancel={() => setShowModal(false)}
     show={showModal}
    />
   )}
  </>
 )
}

export default FubIntegrationCard

const ItemBlk: FCC<{
 value?: string
 label?: string
}> = ({ label, value }) => {
 return (
  <div className="w-100 twilio-Item-blk">
   <div>{label} :</div>
   <div>
    <strong>{value}</strong>
   </div>
  </div>
 )
}
